var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSomeTwitterCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 35",
    width: 35,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0C7.83502 0 0 7.83502 0 17.5C0 27.165 7.83502 35 17.5 35ZM25.9294 13.5693V13.0225C26.7106 12.4365 27.4137 11.7334 27.9606 10.9131C27.2575 11.2256 26.4372 11.46 25.6169 11.5381C26.4762 11.0303 27.1012 10.249 27.4137 9.27246C26.6325 9.74121 25.734 10.0928 24.8356 10.2881C24.0544 9.46777 22.9997 8.99902 21.8278 8.99902C19.5622 8.99902 17.7262 10.835 17.7262 13.1006C17.7262 13.4131 17.7653 13.7256 17.8434 14.0381C14.445 13.8428 11.3981 12.2021 9.36686 9.74121C9.0153 10.3271 8.81999 11.0303 8.81999 11.8115C8.81999 13.2178 9.52311 14.4678 10.6559 15.21C9.99186 15.1709 9.3278 15.0146 8.78092 14.7021V14.7412C8.78092 16.7334 10.1872 18.374 12.0622 18.7646C11.7497 18.8428 11.359 18.9209 11.0075 18.9209C10.7648 18.9209 10.5529 18.8901 10.3172 18.8559C10.2873 18.8516 10.257 18.8472 10.2262 18.8428C10.734 20.4834 12.2575 21.6553 14.0544 21.6943C12.6481 22.7881 10.8903 23.4521 8.97624 23.4521C8.62467 23.4521 8.31217 23.4131 7.99967 23.374C9.79655 24.5459 11.945 25.21 14.2887 25.21C21.8278 25.21 25.9294 18.999 25.9294 13.5693Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSomeTwitterCircle);
export default __webpack_public_path__ + "static/media/some-twitter-circle.912c1f9f83c6342d006c52d74707ea7d.svg";
export { ForwardRef as ReactComponent };